import React, { useEffect, useState } from 'react';
import { Routes, Route, Link } from "react-router-dom";
import { Card } from 'react-bootstrap'
import { useLocation } from "react-router-dom";
import NotAvailable from 'components/common/NotAvailable';


//import NavbarMain from 'components/general/NavbarMain';
import Home from 'pages/Home';
import { About } from 'pages/About';
import Test from 'pages/Test';

import "styles/structure/Loader.scss";


import Schedule from 'pages/ScheduleContext';
import BioDetail from 'pages/BioDetail';
import Results from 'pages/Results';
import Bracket from 'pages/Bracket';
import PoolStanding from 'pages/PoolStandingContext';
import EventRanking from 'pages/EventRanking';
import LiveIndividualMatches from 'pages/LiveIndividualMatches';
import LiveTeamMatches from 'pages/LiveTeamMatches';
import DisciplineMenu from 'components/common/DisciplineMenu';
import ScheduleGrid from 'pages/ScheduleGrid';
import Medallists from 'pages/Medallists';
import NocList from 'pages/NocList';
import CompetitionStatus from 'pages/CompetitionStatus';
import HearingSchedule from 'pages/HearingSchedule';

import { useGetRoutes, useGetLanguages, useGetFunctionRoutes } from 'helpers/commonCodes';
//import MainContainerWithRouter from 'components/common/main-container/MainContainer';
import Records from 'pages/Records';
import TodayMatches from 'pages/TodayMatches';
import Athletes from 'pages/Athletes';
import Placings from 'pages/Placings';
import Reports from 'pages/Reports';
import Medal from 'pages/Medal';
import MultiMedallists from 'pages/MultiMedallist';
import { useGetPath } from 'helpers/urlFriendly';

import Teams from 'pages/Teams';
import Coaches from 'pages/Coaches';
import TechnicalOfficials from 'pages/TechnicalOfficials';
import Horses from 'pages/Horses';
import Entries from 'pages/Entries';

import ScheduleByNoc from 'pages/ScheduleByNoc';
import EntriesByNoc from 'pages/EntriesByNoc';
import MedallistsByNoc from 'pages/MedallistsByNoc';
import ProfilesByNoc from 'pages/ProfileByNoc';
import MainContainerWithRouter from 'components/common/main-container/MainContainer1';


/* 
Structure 
language/path/discipline/date/event

        console.log("Value0   " + res[0]) //Nada
        console.log("Value1   " + res[1]) //Championship
        console.log("Value2   " + res[2]) //Language 
        console.log("Value3   " + res[3]) //path
    
    
        console.log("Value4   " + res[4]) //phase
        console.log("Value5   " + res[5]) //unit

    const mcompetition = res[1];
    const mlanguage = res[2];
    const mpath = res[3]


*/

export default function ApplicationRouter() {
    const location = useLocation();
    const dataLanguages = useGetLanguages()

    var res = location.pathname?.split("/");
    let obj = useGetPath()

    if (!dataLanguages?.languages) { return <NotAvailable /> }

    let comp = [];
    dataLanguages && dataLanguages?.languages?.forEach((item, index) => {
        let objUrl = obj(item.lang);
        comp.push(< Route key={`RouteAthletes${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathAthletes}`} element={< Athletes />} >
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathAthletes}/:mirs_discipline/`} element={<Athletes />} />
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathAthletes}/:mirs_discipline/:mirs_noc`} element={<Athletes />} />
        </Route>)


        comp.push(< Route key={`RouteTeams${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathTeams}`} element={< Teams />} >
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathTeams}/:mirs_discipline/`} element={<Teams />} />
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathTeams}/:mirs_discipline/:mirs_noc`} element={<Teams />} />
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathTeams}/:mirs_discipline/:mirs_noc/:mirs_event`} element={<Teams />} />
        </Route>)

        comp.push(< Route key={`RouteCoaches${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathCoaches}`} element={< Coaches />} >
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathCoaches}/:mirs_discipline/`} element={<Coaches />} />
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathCoaches}/:mirs_discipline/:mirs_noc`} element={<Coaches />} />
        </Route>)

        comp.push(< Route key={`RouteTechnicalOfficials${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathTechnicalOfficials}`} element={< TechnicalOfficials />} >
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathTechnicalOfficials}/:mirs_discipline/`} element={<TechnicalOfficials />} />
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathTechnicalOfficials}/:mirs_discipline/:mirs_noc`} element={<TechnicalOfficials />} />
        </Route>)

        comp.push(< Route key={`RouteHorses${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathHorses}`} element={< Horses />} >
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathHorses}/:mirs_discipline/`} element={<Horses />} />
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathHorses}/:mirs_discipline/:mirs_noc`} element={<Horses />} />
        </Route>)

        comp.push(< Route key={`RouteEntries${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathEntries}`} element={< Entries />} >
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathEntries}/:mirs_discipline/`} element={<Entries />} />
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathEntries}/:mirs_discipline/:mirs_noc`} element={<Entries />} />
        </Route>)


        comp.push(<Route key={`RouteBioDetail${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathBio}/:mirs_code`} element={<BioDetail />} />)
        comp.push(<Route key={`RouteBracket${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathBracket}/:mirs_discipline/:mirs_event_rsc/`} element={<Bracket />} />)

        //comp.push(<Route key={`RouteDisciplineMenu${index}`} path={`/:mirs_competition/:mirs_language/disciplines/`} element={<DisciplineMenu />} />)

        comp.push(<Route key={`RouteEventRanking${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathRanking}/:mirs_discipline/:mirs_event_rsc/`} element={<EventRanking />} />)
        comp.push(<Route key={`RouteLiveIndividualMatches${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathLiveIndividual}/:mirs_discipline/`} element={<LiveIndividualMatches />} />)
        comp.push(<Route key={`RouteLiveTeamMatches${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathLiveTeam}/:mirs_discipline/`} element={<LiveTeamMatches />} />)



        comp.push(<Route key={`RouteMedal${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathMedal}`} element={<Medal />} >
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathMedal}/:mirs_discipline`} element={<Medal />} />
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathMedal}/:mirs_discipline/:mirs_noc`} element={<Medal />} />
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathMedal}/:mirs_discipline/:mirs_noc/:mirs_gender`} element={<Medal />} />
        </Route>)

        comp.push(<Route key={`RouteMedallists${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathMedallists}`} element={<Medallists />} >
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathMedallists}/:mirs_discipline`} element={<Medallists />} />
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathMedallists}/:mirs_discipline/:mirs_event`} element={<Medallists />} />
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathMedallists}/:mirs_discipline/:mirs_event/:mirs_noc`} element={<Medallists />} />
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathMedallists}/:mirs_discipline/:mirs_event/:mirs_noc/:mirs_medal`} element={<Medallists />} />
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathMedallists}/:mirs_discipline/:mirs_event/:mirs_noc/:mirs_medal/:mirs_date`} element={<Medallists />} />
        </Route>)

        comp.push(<Route key={`RouteMultiMedallists${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathMultiMedallists}`} element={<MultiMedallists />} >
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathMultiMedallists}/:mirs_discipline`} element={<MultiMedallists />} />
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathMultiMedallists}/:mirs_discipline/:mirs_noc`} element={<MultiMedallists />} />
        </Route>)



        comp.push(<Route key={`RouteNocList${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathNocList}`} element={<NocList />} />)
        comp.push(<Route key={`RoutePlacings${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathPlacing}/:mirs_discipline/`} element={<Placings />} />)
        comp.push(< Route key={`RouteRecords${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathRecords}`} element={< Records />} >
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathRecords}/:mirs_discipline/`} element={<Records />} />
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathRecords}/:mirs_discipline/:mirs_event`} element={<Records />} />
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathRecords}/:mirs_discipline/:mirs_event/:mirs_noc`} element={<Records />} />
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathRecords}/:mirs_discipline/:mirs_event/:mirs_noc/:mirs_brokenRecords`} element={<Records />} />
        </Route>)
        comp.push(<Route key={`RouteReports${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathReports}`} element={<Reports />} >
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathReports}/:mirs_discipline`} element={<Reports />} />
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathReports}/:mirs_discipline/:mirs_event`} element={<Reports />} />
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathReports}/:mirs_discipline/:mirs_event/:mirs_pdftype`} element={<Reports />} />
        </Route>)
        comp.push(<Route key={`RouteResults${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathResult}/:mirs_discipline/:mirs_event_rsc`} element={<Results />} >
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathResult}/:mirs_discipline/:mirs_event_rsc/:mirs_rsc/`} element={<Results />} />
        </Route>)

        comp.push(< Route key={`RouteSchedule${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathSchedule}`} element={< Schedule />} >
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathSchedule}/:mirs_discipline`} element={<Schedule />} />
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathSchedule}/:mirs_discipline/:mirs_date`} element={<Schedule />} />
            <Route path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathSchedule}/:mirs_discipline/:mirs_date/:mirs_event`} element={<Schedule />} />
        </Route >)



        comp.push(<Route key={`RouteScheduleGrid${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathCompetitionschedule}/`} element={< ScheduleGrid />} />)

        comp.push(<Route key={`RouteScheduleByNoc${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathScheduleByNoc}/:mirs_noc`} element={< ScheduleByNoc />} />)
        comp.push(<Route key={`RouteEntriesByNoc${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathEntriesByNoc}/:mirs_noc`} element={< EntriesByNoc />} />)
        comp.push(<Route key={`RouteMedallistsByNoc${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathMedallistsByNoc}/:mirs_noc`} element={< MedallistsByNoc />} />)
        comp.push(<Route key={`RouteProfileByNoc${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathProfileByNoc}/:mirs_noc`} element={< ProfilesByNoc />} />)


        comp.push(<Route key={`RoutePoolStanding${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathPool}/:mirs_discipline/:mirs_event_rsc/`} element={<PoolStanding />} />)

        comp.push(<Route key={`RouteTodayMatches${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathTodayMatches}/:mirs_discipline/:mirs_date`} element={<TodayMatches />} />)
        comp.push(<Route key={`RouteTodayMatchesAthleteDate${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathTodayAthMatches}/:mirs_discipline/:mirs_date`} element={<TodayMatches type={'A'} />} />)
        comp.push(<Route key={`RouteTodayMatchesTeamDate${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathTodayTeamMatches}/:mirs_discipline/:mirs_date`} element={<TodayMatches type={'T'} />} />)

        comp.push(<Route key={`RouteCompetitionStatus${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathCompetitionStatus}/:mirs_discipline`} element={<CompetitionStatus />} />)
        comp.push(<Route key={`RouteHearingSchedule${index}`} path={`/:mirs_competition/:mirs_language/${objUrl.pathFriendly.pathHearingSchedule}/:mirs_discipline`} element={<HearingSchedule />} />)
    });


    return (
        <>

            <Routes>
                <Route element={<NoMatch />} />
                <Route path="test/:id" element={<Test />} />
                <Route path="home" element={<Home />} />
                <Route path="about" element={<About />} />
                <Route path="*" element={<NoMatch />} />
                <Route path="/" element={<MainContainerWithRouter />}>
                    {comp}
                </Route>
            </Routes>
        </>


    )


}
function NoMatch() {
    return (
        <Card>
            <Card.Header>Error MIRS</Card.Header>
            <Card.Body>
                <Card.Title>Problem</Card.Title>
                <Card.Text>

                    <Link to="/">Go to the home page</Link>
                </Card.Text>
            </Card.Body>
        </Card>
    );
}
//export default withTranslation()(AplicationRouter);